import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { ExclamationMarkSvg } from 'components/icons';
import { ErrorLabel, Icon } from './atoms';

const template = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6px;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Icon,
      name: 'ErrorIcon',
      displayValue: ({ }) => ExclamationMarkSvg({}),
    },
    {
      component: ErrorLabel,
      name: 'ErrorLabel',
      displayValue: ({ error }) => error,
    }
  ]
})